import { z } from "zod";

/**
 * The OpenRouter-style `reasoning` request object. Chat-completions upstreams
 * don't accept it — the proxy translates it into the model's native reasoning
 * toggle (chat_template_kwargs.enable_thinking / reasoning_effort) before
 * dispatch. Both fields optional.
 */
export const ReasoningObjectSchema = z.object({
  enabled: z.boolean().optional(),
  effort: z.string().optional(),
});

export type ReasoningObject = z.infer<typeof ReasoningObjectSchema>;

/**
 * Forwarded verbatim to the engine's chat-template renderer as vLLM/SGLang
 * `chat_template_kwargs`. `enable_thinking` (Qwen/GLM-family templates) and
 * `thinking` (Kimi K2/K3, DeepSeek-family templates) are the keys we reason
 * about (typed as real booleans); `.passthrough()` forwards any other
 * model-template-specific kwargs untouched.
 */
export const ChatTemplateKwargsSchema = z
  .object({
    enable_thinking: z.boolean().optional(),
    thinking: z.boolean().optional(),
  })
  .passthrough();

export type ChatTemplateKwargs = z.infer<typeof ChatTemplateKwargsSchema>;
